var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _g, _rect6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemsCreatedPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 190,
    viewBox: "0 0 224 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 31.1719,
    width: 224,
    height: 158.757,
    rx: 8,
    fill: "#9868F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115.509,
    y: 96.8911,
    width: 86,
    height: 14,
    rx: 7,
    fill: "#D4C0F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9941,
    y: 96.4146,
    width: 70,
    height: 68,
    rx: 6,
    fill: "#D4C0F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.509,
    y: 123.891,
    width: 88,
    height: 14,
    rx: 7,
    fill: "#D4C0F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.509,
    y: 150.891,
    width: 53,
    height: 14,
    rx: 7,
    fill: "#D4C0F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1843,
    cy: 60.5311,
    r: 6.52427,
    fill: "#B795F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5825,
    cy: 60.5311,
    r: 6.52427,
    fill: "#B795F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9806,
    cy: 60.5311,
    r: 6.52427,
    fill: "#EFE5FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11899_6873)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.573,
    y: 2.8999,
    width: 64.1553,
    height: 64.1553,
    rx: 8,
    fill: "#B795F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11899_6873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 15,
    width: 40,
    height: 41
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 15.4146,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11899_6873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.695 43.7481H165.472V36.9147H172.333V34.1368H165.472V27.0814H162.695V34.1368H155.667V36.9147H162.695V43.7481ZM164.008 52.0814C161.707 52.0814 159.545 51.6439 157.521 50.7689C155.498 49.8939 153.732 48.7018 152.222 47.1926C150.713 45.6832 149.521 43.9161 148.646 41.8914C147.771 39.8667 147.333 37.7032 147.333 35.401C147.333 33.0987 147.771 30.9351 148.646 28.9101C149.521 26.8854 150.713 25.123 152.222 23.623C153.732 22.123 155.499 20.9355 157.523 20.0605C159.548 19.1855 161.712 18.748 164.014 18.748C166.316 18.748 168.48 19.1855 170.505 20.0605C172.529 20.9355 174.292 22.123 175.792 23.623C177.292 25.123 178.479 26.8869 179.354 28.9147C180.229 30.9425 180.667 33.1067 180.667 35.4072C180.667 37.708 180.229 39.8701 179.354 41.8935C178.479 43.9168 177.292 45.6814 175.792 47.1872C174.292 48.693 172.528 49.8853 170.5 50.7639C168.472 51.6422 166.308 52.0814 164.008 52.0814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11899_6873",
    x: 119.673,
    y: -0.0000972748,
    width: 87.9554,
    height: 87.9553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11899_6873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11899_6873",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemsCreatedPlaceholder);
export default __webpack_public_path__ + "static/media/no-items-created-placeholder.3852d967644c5164e2ac24e804295e14.svg";
export { ForwardRef as ReactComponent };